import { useMemo } from "react";

import NewClient from "../new-client";
import NewClientForExistingCase from "../new-client-existing-case";
import NewCaseForExistingClient from "../new-existing-client";
import NewChangesTabs from "../../new-client-dashboard/NewChangesTabs";

const AddNewCase = ({
  subActiveTab,
  setSubActiveTab,
  newClientData,
  existingClientData,
  existingCaseData,
  newClientOnChange,
  existingClientOnChange,
  existingCaseOnChange,
  isEmailValid,
  setEmailValid,
  isPhoneValid,
  setPhoneValid,
  loading,
  setLoading,
  fieldStates,
  sourceTypes,
  sourceCategories,
  caseSources,
  caseTypes,
  insuranceTypes,
  insuranceNewTypes,
  defendantTypes,
  reportingagencyTypes,
  state,
  homeStateIntake,
  setHomeStateIntake,
  homeStateClient,
  setHomeStateClient,
  homeStateDefendant,
  setHomeStateDefendant,
  homeStateSource,
  setHomeStateSource,
  setFirstTime,
  pendingLeadData,
  pendingLeadAvailable,
  storedLeadData,
  setStoreLink,
  loadingSave,
  setLoadingSave,
  setShowPopup,
  setShowNormal,
}) => {
  const handleRadioChange = (e) => {
    setSubActiveTab(e);
    setFirstTime(false);
    const storedLeadData = JSON.parse(localStorage.getItem("LeadData"));
    if (storedLeadData && subActiveTab === storedLeadData.LeadActiveTab) {
      return;
    }
  };

  const mainTabs = useMemo(() => {
    const tabs = [];
    //

    tabs.push({
      id: "new-client",
      label: "New Case For New Client",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleRadioChange("new-client"),
      leftHand: false,
    });

    tabs.push({
      id: "existing-client",
      label: "New Case For Existing Client",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleRadioChange("existing-client"),
      leftHand: false,
    });

    tabs.push({
      id: "new-client-existing-case",
      label: "New Client for Existing Case",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleRadioChange("new-client-existing-case"),
      leftHand: false,
    });

    return tabs;
  }, []);

  return (
    <>
      <NewChangesTabs
        currentTab={subActiveTab}
        tabsData={mainTabs}
        height={25}
        labelClass=" justify-content-start pe-2"
      />
      <div className="row mx-auto m-t-5" style={{}}>
        <div className="col-md-12 p-r-5" style={{ paddingLeft: "0px" }}>
          {subActiveTab === "new-client" && ( // New Client New Case
            <NewClient
              data={newClientData}
              onChange={newClientOnChange}
              isEmailValid={isEmailValid}
              setEmailValid={setEmailValid}
              isPhoneValid={isPhoneValid}
              setPhoneValid={setPhoneValid}
              loading={loading}
              setLoading={setLoading}
              fieldStates={fieldStates}
              sourceTypes={sourceTypes}
              sourceCategories={sourceCategories}
              caseSources={caseSources}
              caseTypes={caseTypes}
              insuranceTypes={insuranceTypes}
              insuranceNewTypes={insuranceNewTypes}
              defendantTypes={defendantTypes}
              reportingagencyTypes={reportingagencyTypes}
              state={state}
              homeStateIntake={homeStateIntake}
              setHomeStateIntake={setHomeStateIntake}
              homeStateClient={homeStateClient}
              setHomeStateClient={setHomeStateClient}
              homeStateDefendant={homeStateDefendant}
              setHomeStateDefendant={setHomeStateDefendant}
              homeStateSource={homeStateSource}
              setHomeStateSource={setHomeStateSource}
              pendingLeadData={pendingLeadData}
              pendingLeadAvailable={pendingLeadAvailable}
              storedLeadData={storedLeadData}
              subActiveTab={subActiveTab}
              setStoreLink={setStoreLink}
              loadingSave={loadingSave}
              setLoadingSave={setLoadingSave}
              setShowPopup={setShowPopup}
              setShowNormal={setShowNormal}
            />
          )}
          {subActiveTab === "existing-client" && ( // Exisitng Client New Case
            <NewCaseForExistingClient
              data={existingClientData}
              onChange={existingClientOnChange}
              isEmailValid={isEmailValid}
              setEmailValid={setEmailValid}
              isPhoneValid={isPhoneValid}
              setPhoneValid={setPhoneValid}
              loading={loading}
              setLoading={setLoading}
              sourceTypes={sourceTypes}
              sourceCategories={sourceCategories}
              caseSources={caseSources}
              caseTypes={caseTypes}
              insuranceTypes={insuranceTypes}
              insuranceNewTypes={insuranceNewTypes}
              defendantTypes={defendantTypes}
              reportingagencyTypes={reportingagencyTypes}
              state={state}
              homeStateDefendant={homeStateDefendant}
              setHomeStateDefendant={setHomeStateDefendant}
              homeStateSource={homeStateSource}
              setHomeStateSource={setHomeStateSource}
              pendingLeadData={pendingLeadData}
              pendingLeadAvailable={pendingLeadAvailable}
              storedLeadData={storedLeadData}
              subActiveTab={subActiveTab}
              setStoreLink={setStoreLink}
              setLoadingSave={setLoadingSave}
              setShowPopup={setShowPopup}
              setShowNormal={setShowNormal}
              fieldStates={fieldStates}
              loadingSave={loadingSave}
            />
          )}
          {subActiveTab === "new-client-existing-case" && ( // New Client Existing Case
            <NewClientForExistingCase
              data={existingCaseData}
              onChange={existingCaseOnChange}
              isEmailValid={isEmailValid}
              setEmailValid={setEmailValid}
              isPhoneValid={isPhoneValid}
              setPhoneValid={setPhoneValid}
              loading={loading}
              setLoading={setLoading}
              sourceTypes={sourceTypes}
              sourceCategories={sourceCategories}
              caseSources={caseSources}
              insuranceTypes={insuranceTypes}
              insuranceNewTypes={insuranceNewTypes}
              state={state}
              homeStateClient={homeStateClient}
              setHomeStateClient={setHomeStateClient}
              homeStateSource={homeStateSource}
              setHomeStateSource={setHomeStateSource}
              pendingLeadData={pendingLeadData}
              pendingLeadAvailable={pendingLeadAvailable}
              storedLeadData={storedLeadData}
              subActiveTab={subActiveTab}
              setStoreLink={setStoreLink}
              setLoadingSave={setLoadingSave}
              setShowPopup={setShowPopup}
              setShowNormal={setShowNormal}
              fieldStates={fieldStates}
              loadingSave={loadingSave}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AddNewCase;
